// extracted by mini-css-extract-plugin
module.exports = {"scanner":"StatusPanel_scanner__elMKE","statusPanel":"StatusPanel_statusPanel__CzlUu","textWrapper":"StatusPanel_textWrapper__2QPCa"};